<mgl-map
    [style]="'https://mobil.itmc.tu-dortmund.de/mvt/style.json'"
    [zoom]="[14]"
    [center]="[7.4128, 51.4875]"
    [maxZoom]="20"
    [minZoom]="12"
    (mapLoad)="mapLoaded($event)"
    (mapError)="mapError($event)"
    (mapResize)="mapResized()"
    (sourceData)="sourceDataLoaded($event)"
    [class.hidden]="(this.loaded | async) === false"
    >
  <mgl-control mglNavigation position="top-right" [visualizePitch]="true"></mgl-control>
  @if (showCategories) {
    <app-map-control-category position="bottom-right" [categories]="categories" (enabledCategoryIds)="updateFilter($event)" [enabledCategories]="enabledCategories"></app-map-control-category>
  }
  <app-map-control-geolocation [trackUserLocation]="true" position="bottom-right"></app-map-control-geolocation>
  <app-map-control-home position="bottom-right"></app-map-control-home>
  @if (showSearch && featureCollection !== null) {
    <app-map-control-search position="bottom-right" [features]="featureCollection.features" (selectedFeature)="openPOI($event)"></app-map-control-search>
  }
</mgl-map>

<div class="navigation-exit">
  @if (isNavigating()) {
    <ion-button color="danger" (click)="exitNavigation()">Navigation beenden</ion-button>
  }
</div>

<ion-modal id="map-detail-view" [isOpen]="!!selectedPOI" [initialBreakpoint]="INITIAL_MODAL_BREAKPOINT" [breakpoints]="[0, 0.17, INITIAL_MODAL_BREAKPOINT, 0.6, 0.9, 1.0]" (didDismiss)="this.selectedPOI = null" [showBackdrop]="false" [backdropBreakpoint]="0.6">
  <ng-template>
    <ion-content class="detail-view">
      <div class="top-row ion-padding-top ion-padding-horizontal">
        @if (selectedPOI?.category) {
          <ion-note color="primary" class="flex gap-2 ion-align-items-center">
            <i class="fas {{ selectedPOI.category.icon }}"></i>
            <span>
              {{ selectedPOI.category.name[languageCode] }}
            </span>
          </ion-note>
        }

        <div class="flex gap-2">
          <div class="circular-button">
            <button (click)="share(this.selectedPOI)">
              <ion-icon name="share-outline"></ion-icon>
            </button>
          </div>

          <div class="circular-button">
            <button (click)="this.selectedPOI = null">
              <ion-icon name="close-outline"></ion-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="buttons-row ion-padding">
        <div class="buttons">
          @if (selectedPOI) {
            <ion-button size="small" shape="round" (click)="addRoute(selectedPOI.coordinates)" mode="ios">
              <ion-icon slot="start" name="analytics-outline"></ion-icon>
              Route
              @if (loadingCurrentPosition) {
                <ion-spinner name="crescent" class="ion-margin-start"></ion-spinner>
              }
            </ion-button>

            @if (selectedPOI?.hasStudySpaces) {
              <ion-button size="small" shape="round" mode="ios" (click)="openRoomOverview(selectedPOI?.id)">
                <ion-icon slot="start" name="time"></ion-icon>
                {{ 'study-areas.studySpaces.selectLocation.occupancySchedule' | translate }}
              </ion-button>
            }

            @if (selectedPOI?.occupancyLevel) {
              <div class="occupancy">
                <div id="click-trigger" class="occupancy-level {{ selectedPOI.occupancyLevel.toLowerCase() }}"></div>
                <ion-popover trigger="click-trigger" triggerAction="click">
                  <ng-template>
                    <ion-content class="ion-padding">
                      <div class="occupancy-popover">
                        <span>{{ 'campus-navi.occupancy.occupancy' | translate }}</span>
                        <span class="{{ selectedPOI.occupancyLevel.toLowerCase() }}">{{ 'campus-navi.occupancy.' + selectedPOI.occupancyLevel.toLowerCase() | translate }}</span>
                      </div>
                    </ion-content>
                  </ng-template>
                </ion-popover>
              </div>
            }

            <ion-button size="small" shape="round" color="light" (click)="copyCoordinates(selectedPOI)" mode="ios">
              <ion-icon slot="icon-only" name="clipboard-outline"></ion-icon>
            </ion-button>
          }
        </div>
      </div>        

      <div class="ion-padding-start ion-padding-end">
        @if (selectedPOI?.name) {
          <h1 class="margin-top-none">{{ selectedPOI.name[languageCode] }}</h1>
        }

        @if (selectedPOI?.description?.[languageCode]) {
          <p [innerHTML]="selectedPOI?.description?.[languageCode]"></p>
        }
      </div>

      @if (selectedPOI?.groupedRooms) {
        <ion-list>
          @for (group of selectedPOI?.groupedRooms | keyvalue; track group.key) {
            <ion-item>
              <ion-label>{{ group.value.floor.name }}</ion-label>
            </ion-item>
            @for (room of group.value.rooms; track room.id) {
              <ion-item class="ion-padding-start">
                <ion-label>
                  {{ room.roomNo }}
                  @if(selectedPOI.roomDescriptions?.[room.id]?.[languageCode]) {
                    <p [innerHTML]="selectedPOI.roomDescriptions[room.id][languageCode]"></p>
                  }
                </ion-label>
                <ion-note slot="end" class="ion-text-wrap">
                  {{ getMetaRoom(room?.id)?.currentAppointment?.end | humanizedDate }}
                </ion-note>
                @if (selectedPOI.hasStudySpaces) {
                  <ion-button
                      slot="end"
                      fill="clear"
                      (click)="openTimetable(selectedPOI?.id, room?.id)"
                      [color]="getMetaRoom(room?.id)?.currentlyBlocked ? 'warning' : 'primary'"
                      >
                    <ion-icon name="time" slot="icon-only"></ion-icon>
                  </ion-button>
                }
              </ion-item>
            }
          }
        </ion-list>
      }
    </ion-content>
  </ng-template>
</ion-modal>
